export default __webpack_public_path__ + "static/media/cover-autofollow@2x.ba8f71ed.png";